export const API_BASE = process.env.REACT_APP_ROLES_API ?? '';

export const REQUEST_BASE_URL = '/ECMv6/role-recommendations';

export const ERROR_MESSAGE = 'Service unavailable. Please try again later.';

export const OPERATORS_WITH_NO_VALIDATION = ['IS NULL', 'IS NOT NULL'];

export const DISABLE_CACHE_STALE_TIME = 0 as const;
